import Vue from "vue";

Vue.component("EvaluationMoveForms", () => import("./show/MoveForms.vue"));
Vue.component("EvaluationMoves", () => import("./show/Moves.vue"));
Vue.component("EvaluationNew", () => import("./EvaluationNew.vue"));
Vue.component("EvaluationShow", () => import("./show/Show.vue"));
Vue.component("EvaluationTimeline", () => import("./show/Timeline.vue"));
Vue.component("PriceGenerator", () => import("./PriceGenerator.vue"));
